// $(document).bind('mobileinit', function(){ 
//     $.mobile.metaViewportContent = 'width=device-width'; 
// });
window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};
$('body').on('click', '.slider-nav .thumbnail-image', function() {
    //code
  $(".currentSlideSelection").removeClass("currentSlideSelection");
  $(this).addClass("currentSlideSelection");
  var mediaId = $(".currentSlideSelection").find(".product-media-container").attr("data-media");
 
    var slideno = $('.slider-banner-image .tp-productmedia-'+mediaId).parent('.slider-banner-image').attr('data-slick-index');
    $('.slider-for').slick('slickGoTo', slideno);
  

});

$(document).ready(function() {
    $(".product-detail-wrapper .product__media-wrapper media-gallery").fadeIn();
    // $(".homepage-slider").slick({
    //         infinite: true,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         dots:false,
    //         arrows:false,
    //         autoplay: true,
    //         autoplaySpeed: 1500
    // });
    $(".collection-slider-home").slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            dots:false,
            arrows:true,
            responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
              }
            }
        ]
    });
    $(".review-slider").slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            dots:false,
            arrows:false,
            responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true,
                arrows:false,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
              }
            }
        ]
    });
    $(".blog-slider").slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            dots:false,
            arrows:false,
            responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true,
                arrows:false,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
              }
            }
        ]
    });
    $(".product-image-sliderc .inner-wrap .outer-list").slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            dots:false,
            arrows:false,
            responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
              }
            }
        ]
    });
    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: true,
    });

    $('.slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll:1,
        rows: mobileCheck() ? 1 : 2,
        infinite: true,
        dots: false,
        arrows: true,
        focusOnSelect: true,
        responsive: [
        {
          breakpoint: 380,
          settings: {
            vertical: false,
            slidesToShow: 4,
            slidesToScroll:1,
          }
        }
        ]
    });
    const slider = $(".slider-nav");
    slider.on('wheel', (function(e) {
      e.preventDefault();
    
      if (e.originalEvent.deltaY < 0) {
        $(this).slick('slickPrev');
      } else {
        $(this).slick('slickNext');
      }
    }));
   $('.mega-menu').on('mouseover', function() {
    $(this).attr('open','open');
   }).mouseleave(function() {
    $(this).removeAttr('open');
    });
  // Show more text option 
    var showChar = 360;  // How many characters are shown by default
    var ellipsestext = "...";
    var moretext = "Čti více";
    var lesstext = "Čti méně";
    
    //Cut content based on showChar length
    if ($(".collection-wrapper .product-grid-container .tp-subtitle-container p").length) {
        $(".collection-wrapper .product-grid-container .tp-subtitle-container p").each(function() {

            var content = $(this).html();
            console.log(content);
     
            if(content.length > showChar) {
     
                var contentExcert = content.substr(0, showChar);
                var contentRest = content.substr(showChar, content.length - showChar);
                var html = contentExcert + '<span class="toggle-text-ellipses">' + ellipsestext + ' </span> <span class="toggle-text-content">' + contentRest + '</span><a href="javascript:;" class="toggle-text-link">' + moretext + '</a>';
     
                $(this).html(html);
            }
        });
    }
    
    //Toggle content when click on read more link
    $(".toggle-text-link").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        } else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }
        $(this).siblings("span").find(".toggle-text-ellipses").toggle();
        $(this).siblings("span").find(".toggle-text-content").toggleClass("show");
        return false;
    });
    // $('.product-detail-wrapper .slider.slider-for .slick-current .thumbnail-wrap .media img').elevateZoom({
    //   zoomType : 'lens',
    //   lensShape : 'round',
    //   lensSize : 200
    // });
    // setTimeout(function() {
    //     var featuredimg = $('.product-detail-wrapper .slider.slider-for .slick-current .thumbnail-wrap .media img').attr('src');
    //     console.log("img",featuredimg);
    //     jQuery('.zoomContainer .zoomLens').css("background-size", "auto");
    //     jQuery('.zoomContainer .zoomLens').css("background-image", "url(" + featuredimg + ")");
    // }, 1500);
    // $(".slider.slider-for").on("afterChange", function (){
    //     var featuredimg2 = $('.product-detail-wrapper .slider.slider-for .slick-current .thumbnail-wrap .media img').attr('src');
    //     console.log("img",featuredimg2);
    //     jQuery('.zoomContainer .zoomLens').css("background-size", "auto");
    //     jQuery('.zoomContainer .zoomLens').css("background-image", "url(" + featuredimg2 + ")");
    // })
    $(".footer .tabs_mb .footer-block__heading").click(function(){
      $(this).parent().toggleClass("active").siblings().removeClass("active");
    });
  
    $(".collection-wrapper .tp-sidebar-container .filter-list .filter-item.has-child .icon-arrow").click(function(){
      $(this).parents().toggleClass("active").siblings().removeClass("active");
    });
  
    var active_collection = $(".collection-wrapper .tp-sidebar-container .filter-list .filter-item a.menu-active").html();
    $(".collection-wrapper .tp-sidebar-container .mb-filter").append(active_collection);

   $(".collection-wrapper .tp-sidebar-container .mb-filter").click(function(){
        $(this).toggleClass('expanded');
      $(".collection-wrapper .tp-sidebar-container .filter-list").toggleClass("filter-nav-active");
      $(".collection-wrapper .tp-sidebar-container .overlay").addClass("overlay-active");
      $(".announcement-bar-section").addClass("hide-bar-j");
    });
    $(".collection-wrapper .tp-sidebar-container .filter-list .close-btn").click(function(){
        $(".collection-wrapper .tp-sidebar-container .filter-list").removeClass("filter-nav-active");
        $(".collection-wrapper .tp-sidebar-container .overlay").removeClass("overlay-active");
         $(".announcement-bar-section").removeClass("hide-bar-j");
    });
  $(".collection-wrapper .tp-sidebar-container .filter-list .filter-item a.menu-active").parents(".filter-item").addClass("main-li-active");
    /*
    $('.tab-menu li a').on('click', function(){
          var target = $(this).attr('data-rel');
          $('.tab-menu li a').removeClass('active');
          $(this).addClass('active');
          $("."+target).fadeIn('slow').siblings(".tab-box").hide();
          $(".blog-articles__article").css('display','none')
          $(".blog-articles__article."+target).css('display','block')
          return false;
    });
   */
  $('.tab-menu li a').on('click', function(){
        var target = $(this).attr('data-rel');
        sortBlogPage(target);
        return false;
    });
    function sortBlogPage(target) {
      $('.tab-menu li a').removeClass('active');
      $(".tab-menu li a[data-rel='"+target+"']").addClass('active');
      $("."+target).fadeIn('slow').siblings(".tab-box").hide();
      $(".blog-articles__article").css('display','none')
      $(".blog-articles__article."+target).css('display','block');
      sessionStorage.setItem("sort-rel",target);
    }
    $(document).ready(function(){
      // $('.accordion-list > li > .answer').hide();
      if(sessionStorage.getItem("sort-rel")!= null) {
        sortBlogPage(sessionStorage.getItem("sort-rel"));
      }
      $('.accordion-list > li h3').click(function() {
        if ($(this).parent().hasClass("active")) {
          $(this).parent().removeClass("active").find(".answer").slideUp();
        } else {
          $(".accordion-list > li.active .answer").slideUp();
          $(".accordion-list > li.active").removeClass("active");
          $(this).parent().addClass("active").find(".answer").slideDown();
        }
        return false;
      });

     // if($('body').hasClass('product')){
        $(".tp-select-option-container").each(function(){
          var selectOption = $('.active.option-btn ',this).html();
          $(this).find('.selected-box').empty().append(selectOption+' <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.41888 1L8.95815 8L16.4974 1" stroke="#2D3949" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
        });  
     // }
    });

    $('.tab-menu ul li a').click(function(){
      if ($(window).width() < 992 ) {
          $('.tab-menu ul').toggleClass("expend");
      }
    });

    $(document).ready(function(){
     var tabs_length = $('.tab-box.tab-infoüberprodukte .accordion-list li').length;
     console.log("ppppp"+tabs_length); 
    });


  function updateVariantStatuses(elem,variantData) {
    setTimeout(function(){ 
        const selectedOptionOneVariants = variantData.filter(variant => elem.find('.option-btn.active').attr('data-value') === variant.option1);
        const inputWrappers = [...elem.find('.product-form__input')];
        inputWrappers.forEach((option, index) => {
          if (index === 0) return;
          const optionInputs = [...option.querySelectorAll('.option-btn')]
          const previousOptionSelected = inputWrappers[index - 1].querySelector('.active').getAttribute('data-value');
          const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
          setInputAvailability(optionInputs, availableOptionInputsValue)
        });
    }, 500);
  }

 function setInputAvailability(listOfOptions, listOfAvailableOptions) {
   console.log(listOfOptions,listOfAvailableOptions);
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('data-value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  
    $(document).on('click', '.tp-product-options .product-form__input .option-btn', function(e) {
      let variantData = JSON.parse($(this).closest('.product-card-wrapper').find('.productJson').html());
      updateVariantStatuses($(this).closest('.product-card-wrapper'),variantData);
      $(this).parents('.product-form__input').find('.option-btn').removeClass('active');
      $(this).addClass('active');
      $('.tp-product-options').removeClass('active');
      $(this).parents('.tp-product-options').addClass('active');
      var selectedVar = [];
     
      $('.tp-product-options.active .product-form__input .active').each(function(){
             var variant_dropdown = $(this).attr('data-value');
             selectedVar.push(variant_dropdown); 
      });
      var joinvar = selectedVar.join('/').replace(/ /g,'').toLowerCase();
      console.log('first',joinvar);
           
      var allAvailableVariants = [];
      
      $(this).parents('.product-card-wrapper').find('.variant-image').each(function(){
        allAvailableVariants.push($(this).attr('data-variant-name').toLowerCase());
      });
      if(allAvailableVariants.indexOf(joinvar) != -1) {
        $(this).parents('.product-card-wrapper').find('.card__media .variant-image').removeClass('active');
      }

      
      $(this).parents('.product-card-wrapper').find('.variant-image').each(function(){
        
        if(allAvailableVariants.indexOf(joinvar) == -1) {
            $(this).parents('.product-card-wrapper').find('.product-form__submit').prop('disabled',true);
            $(this).parents('.product-card-wrapper').find('.product-form__submit').empty().append('Není k dispozici');
              
        } else {
            if($(this).attr('data-variant-name').toLowerCase() == joinvar){
               $(this).addClass('active');
               $(this).parents('.product-card-wrapper').find('#tp-form-variant-id').val($(this).attr('data-variant-id'));
               var productCPrice = $(this).attr('data-variant-cprice');
               var productPrice = $(this).attr('data-variant-price');
               if(productCPrice == "") {
                 $(this).parents('.product-card-wrapper').find('.card__badge').hide();
               } else {
                 $(this).parents('.product-card-wrapper').find('.card__badge').show();
               }
               $(this).parents('.product-card-wrapper').find('.tp-product-bar-sale-price').empty().append(productCPrice);
               $(this).parents('.product-card-wrapper').find('.tp-product-bar-regular-price').empty().append(productPrice); 
               if($(this).attr('data-variant-policy') == 'deny' && $(this).attr('data-variant-quantity') <= 0 ){
                 $(this).parents('.product-card-wrapper').find('.product-form__submit').prop('disabled',true);
                   if($("html").attr('lang') == 'en'){    
                     $(this).parents('.product-card-wrapper').find('.product-form__submit').empty().append('Sold out<div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');
                   }
                 else{
                   (this).parents('.product-card-wrapper').find('.product-form__submit').empty().append('Vyprodáno<div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');                 
                 }
                }
              else if($(this).attr('data-variant-policy') != 'deny' && $(this).attr('data-variant-quantity') >= 0 ){
                  $(this).parents('.product-card-wrapper').find('.product-form__submit').prop("disabled", false);
                   if($("html").attr('lang') == 'en'){    
                    $(this).parents('.product-card-wrapper').find('.product-form__submit').empty().append('Add to cart<div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');
                  }
                 else{
                   $(this).parents('.product-card-wrapper').find('.product-form__submit').empty().append('přidat do košíku<div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');
                 }
              }
               else{
                 $(this).parents('.product-card-wrapper').find('.product-form__submit').prop("disabled", false);
                  if($("html").attr('lang') == 'en'){    
                      $(this).parents('.product-card-wrapper').find('.product-form__submit').empty().append('Add to cart<div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');
                  }
                 else{
                   $(this).parents('.product-card-wrapper').find('.product-form__submit').empty().append('přidat do košíku<div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');
                 }  
               }
             }
          }
      });
    });
    $(".tp-select-option-container .selected-box").click(function(){
      if($(this).siblings(".custom-select").hasClass('opened')){
        $(this).siblings(".custom-select").removeClass("opened");  
        $('.tp-select-options .custom-select').removeClass('opened');
      }else{
        $('.tp-select-options .custom-select').removeClass('opened');
        $(this).siblings(".custom-select").addClass("opened");
      }
    });
    $(".tp-product-bar .bar-inner .product-form").click(function(){
      $('.tp-select-options .custom-select').removeClass('opened');
    });

  
    if($('body').hasClass('product')){
      $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        $('body.product .tp-product-bar').toggleClass('sticky-product-bar',
          scroll >= $('body.product .outer-product-bought-wrap').offset().top
        );
      });
    }
    if($('body').hasClass('collection')){
      $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        $('.collection-wrapper .tp-sidebar-container').toggleClass('sticky-sidebar', scroll >= $('.collection-hero .collection-hero__inner').offset().top);
      });
    }
    $(document).on('click', '.tp-product-bar-options .tp-select-options .option-btn', function(e) {
      

      //console.log('get inner div',$(this).html()); 
      $(this).parents('.tp-select-options').find('.selected-box').empty().append($(this).html()+'<svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.41888 1L8.95815 8L16.4974 1" stroke="#2D3949" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
      $(this).parents('.tp-select-options').find('.custom-select').removeClass("opened");
      
      $(this).parents('.tp-select-options').find('.option-btn').removeClass('active');
      $(this).addClass('active');

      var selectedVar = [];
      $('.tp-product-bar-options .tp-select-options .option-btn.active').each(function(){
             var variant_dropdown = $(this).attr('data-value');
             selectedVar.push(variant_dropdown); 
      });
      var joinvar = selectedVar.join('/').replace(/ /g,'').toLowerCase();
      
      $('.tp-product-variant-dropdown option').each(function(){
       if($(this).attr('data-name').toLowerCase() == joinvar){
         $('.tp-product-variant-dropdown option[value="'+$(this).val()+'"]');
         $('#tp-form-variant-id').val($(this).val());
         $('.tp-product-bar-sale-price').empty().append($(this).attr('data-compare-price'));
         $('.tp-product-bar-regular-price').empty().append($(this).attr('data-regular-price'));
         console.log('here',$(this).attr('data-variant-policy'),$(this).attr('data-variant-quantity'));
         if($(this).attr('data-variant-policy') == 'deny' && $(this).attr('data-variant-quantity') <= 0 ){
           console.log('if here');
           $(this).parents('.tp-product-bar').find('.product-form__submit').prop('disabled',true);
             if($("html").attr('lang') == 'en'){           
                 $(this).parents('.tp-product-bar').find('.product-form__submit').empty().append('<span>Sold out</span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');
             }
             else{
                 $(this).parents('.tp-product-bar').find('.product-form__submit').empty().append('<span>Vyprodáno</span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');
             }
           }
          else if($(this).attr('data-variant-policy') != 'deny' && $(this).attr('data-variant-quantity') >= 0 ){
            $(this).parents('.tp-product-bar').find('.product-form__submit').prop("disabled", false);            
             if($("html").attr('lang') == 'en'){           
                 $(this).parents('.tp-product-bar').find('.product-form__submit').empty().append('<span>Add to cart</span><span class="cart-icon-wrap"><svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.65577 5.06123H30.3891L26.0101 19.6577H7.03471L2.65577 5.06123ZM2.65577 5.06123L1.56104 1.41211M14.333 24.7665C14.333 25.3472 14.1023 25.9041 13.6917 26.3147C13.2811 26.7253 12.7242 26.9559 12.1435 26.9559C11.5628 26.9559 11.0059 26.7253 10.5953 26.3147C10.1847 25.9041 9.95401 25.3472 9.95401 24.7665M23.0908 24.7665C23.0908 25.3472 22.8602 25.9041 22.4496 26.3147C22.039 26.7253 21.4821 26.9559 20.9014 26.9559C20.3207 26.9559 19.7638 26.7253 19.3532 26.3147C18.9426 25.9041 18.7119 25.3472 18.7119 24.7665" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');                       
             }
             else{
              $(this).parents('.tp-product-bar').find('.product-form__submit').empty().append('<span>přidat do košíku</span><span class="cart-icon-wrap"><svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.65577 5.06123H30.3891L26.0101 19.6577H7.03471L2.65577 5.06123ZM2.65577 5.06123L1.56104 1.41211M14.333 24.7665C14.333 25.3472 14.1023 25.9041 13.6917 26.3147C13.2811 26.7253 12.7242 26.9559 12.1435 26.9559C11.5628 26.9559 11.0059 26.7253 10.5953 26.3147C10.1847 25.9041 9.95401 25.3472 9.95401 24.7665M23.0908 24.7665C23.0908 25.3472 22.8602 25.9041 22.4496 26.3147C22.039 26.7253 21.4821 26.9559 20.9014 26.9559C20.3207 26.9559 19.7638 26.7253 19.3532 26.3147C18.9426 25.9041 18.7119 25.3472 18.7119 24.7665" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');                       
             }
           }
           else{
             $(this).parents('.tp-product-bar').find('.product-form__submit').prop("disabled", false);            
             if($("html").attr('lang') == 'en'){           
                 $(this).parents('.tp-product-bar').find('.product-form__submit').empty().append('<span>Add to cart</span><span class="cart-icon-wrap"><svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.65577 5.06123H30.3891L26.0101 19.6577H7.03471L2.65577 5.06123ZM2.65577 5.06123L1.56104 1.41211M14.333 24.7665C14.333 25.3472 14.1023 25.9041 13.6917 26.3147C13.2811 26.7253 12.7242 26.9559 12.1435 26.9559C11.5628 26.9559 11.0059 26.7253 10.5953 26.3147C10.1847 25.9041 9.95401 25.3472 9.95401 24.7665M23.0908 24.7665C23.0908 25.3472 22.8602 25.9041 22.4496 26.3147C22.039 26.7253 21.4821 26.9559 20.9014 26.9559C20.3207 26.9559 19.7638 26.7253 19.3532 26.3147C18.9426 25.9041 18.7119 25.3472 18.7119 24.7665" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');                       
             }
             else{
              $(this).parents('.tp-product-bar').find('.product-form__submit').empty().append('<span>přidat do košíku</span><span class="cart-icon-wrap"><svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.65577 5.06123H30.3891L26.0101 19.6577H7.03471L2.65577 5.06123ZM2.65577 5.06123L1.56104 1.41211M14.333 24.7665C14.333 25.3472 14.1023 25.9041 13.6917 26.3147C13.2811 26.7253 12.7242 26.9559 12.1435 26.9559C11.5628 26.9559 11.0059 26.7253 10.5953 26.3147C10.1847 25.9041 9.95401 25.3472 9.95401 24.7665M23.0908 24.7665C23.0908 25.3472 22.8602 25.9041 22.4496 26.3147C22.039 26.7253 21.4821 26.9559 20.9014 26.9559C20.3207 26.9559 19.7638 26.7253 19.3532 26.3147C18.9426 25.9041 18.7119 25.3472 18.7119 24.7665" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');                       
             }
           }
       }
      });
     }); 

    $(document).on('click', '.tp-variant-select-box .tp-select-options .option-btn', function(e) {
      

      //console.log('get inner div',$(this).html()); 
      $(this).parents('.tp-select-options').find('.selected-box').empty().append($(this).html()+'<svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.41888 1L8.95815 8L16.4974 1" stroke="#2D3949" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
      $(this).parents('.tp-select-options').find('.custom-select').removeClass("opened");
      
      $(this).parents('.tp-select-options').find('.option-btn').removeClass('active');
      $(this).addClass('active');

     }); 

    $('.tp-variant-box.tp-variant-more-than').on('change', function() {
      $(this).find('.option-btn').removeClass('active');
      $('option:selected', this).addClass('active');
      $('.tp-product-options').removeClass('active');
      $(this).parents('.tp-product-options').addClass('active');
      var selectedVar = [];
      $('.tp-product-options.active .product-form__input .active').each(function(){
             var variant_dropdown = $(this).attr('data-value');
             selectedVar.push(variant_dropdown); 
      });
      var joinvar = selectedVar.join('/').replace(/ /g,'').toLowerCase();
      console.log('second',joinvar);
      $(this).parents('.product-card-wrapper').find('.card__media .variant-image').removeClass('active');
      $(this).parents('.product-card-wrapper').find('.variant-image').each(function(){
          if($(this).attr('data-variant-name').toLowerCase() == joinvar){
             $(this).addClass('active');
             var productCPrice = $(this).attr('data-variant-cprice');
             var productPrice = $(this).attr('data-variant-price');
             $(this).parents('.product-card-wrapper').find('.tp-product-bar-sale-price').empty().append(productCPrice);
             $(this).parents('.product-card-wrapper').find('.tp-product-bar-regular-price').empty().append(productPrice);
             $(this).parents('.product-card-wrapper').find('#tp-form-variant-id').val($(this).attr('data-variant-id')); 
             if($(this).attr('data-variant-policy') == 'deny' && $(this).attr('data-variant-quantity') <= 0 ){
               $(this).parents('.product-card-wrapper').find('.product-form__submit').prop('disabled',true);
                 if($("html").attr('lang') == 'en'){           
                   $(this).parents('.product-card-wrapper').find('.product-form__submit').empty().append('Sold out<div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');
                 }
                 else{
                     $(this).parents('.product-card-wrapper').find('.product-form__submit').empty().append('Vyprodáno<div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');
                 }
              }
              else if($(this).attr('data-variant-policy') != 'deny' && $(this).attr('data-variant-quantity') >= 0 ){
                $(this).parents('.product-card-wrapper').find('.product-form__submit').prop("disabled", false);
                 if($("html").attr('lang') == 'en'){           
                   $(this).parents('.product-card-wrapper').find('.product-form__submit').empty().append('Add to cart <div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');
                }
                 else{
                    $(this).parents('.product-card-wrapper').find('.product-form__submit').empty().append('přidat do košíku<div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');
                  }
              }
             else{
               console.log("here");
               $(this).parents('.product-card-wrapper').find('.product-form__submit').prop("disabled", false);
                if($("html").attr('lang') == 'en'){           
                   $(this).parents('.product-card-wrapper').find('.product-form__submit').empty().append('Add to cart <div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');
                }
               else{
                  $(this).parents('.product-card-wrapper').find('.product-form__submit').empty().append('přidat do košíku<div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>');
                }
             }
           }
      });
    });


     // $(document).on('click', '.product .tp-product-options', function(e) {
     //  // setTimeout(function () {
     //       productGallerySelect();
     // //  }, 500);
       
     //   $('.product .product-form__error-message').empty();
     //   $('.product .product-form__error-message-wrapper').attr("hidden",true);
     // });

    if($('body').hasClass('product')){
      var get_global_variant_custom_change = new VariantSelects();
      get_global_variant_custom_change.productGallerySelect();
    }

    // function productGallerySelect(){
    //   debugger;
    //   var select_var = $('.product-variant-id').val();
    //   console.log("aa"+select_var);
    //    var product_handle = $('a.product__title').attr('data-handle');
    //    console.log('title',product_handle);
    //    jQuery.getJSON('/products/'+product_handle+'.js', function(product) {
    //      for (var i = 0; i < product.variants.length; i++) {
    //         var all_variants = product.variants[i].id;
    //         if(select_var == all_variants){
    //           var media_id = product.variants[i].featured_media.id;
    //           var slideno = $('.slider-banner-image .tp-productmedia-'+media_id).parent('.slider-banner-image').attr('data-slick-index');
    //           var slidenoo = $('.thumbnail-image  .tp-productmedia-'+media_id).parent('.thumbnail-image ').attr('data-slick-index');
    //           $('.slider-for').slick('slickGoTo', slideno);
    //           $('.slider-nav').slick('slickGoTo', slidenoo);
    //         }
    //       }
    //    });
    // }
});  

$(document).ready(function(){
   setTimeout(function() {
    var sub_width = 0;
    var sub_height = 0;
    $(".large").css("background","url('" + $(".zoom-area .slider.slider-for .slick-current .product__media img").attr("src") + "') no-repeat");
    $(".zoom-area media-gallery .slider.slider-for").mousemove(function(e){
        if(!sub_width && !sub_height)
        {
            var image_object = new Image();
            image_object.src = $(".zoom-area .slider.slider-for .slick-current .product__media img").attr("src");
            sub_width = image_object.width;
            sub_height = image_object.height;
        }
        else
        {
            var magnify_position = $(this).offset();

            var mx = e.pageX - magnify_position.left;
            var my = e.pageY - magnify_position.top;
            
            if(mx < $(this).width() && my < $(this).height() && mx > 0 && my > 0)
            {
                $(".large").fadeIn(100);
            }
            else
            {
                $(".large").fadeOut(100);
            }
            if($(".large").is(":visible"))
            {
                var rx = Math.round(mx/$(".zoom-area .slider.slider-for .slick-current .product__media img").width()*sub_width - $(".large").width()/2)*-1;
                var ry = Math.round(my/$(".zoom-area .slider.slider-for .slick-current .product__media img").height()*sub_height - $(".large").height()/2)*-1;

                var bgp = rx + "px " + ry + "px";
                
                var px = mx - $(".large").width()/2;
                var py = my - $(".large").height()/2;

                $(".large").css({left: px, top: py, backgroundPosition: bgp});
            }
        }
    });
  }, 1500);   
   $(".slider.slider-for").on("afterChange", function (){
    var sub_width = 0;
    var sub_height = 0;
    $(".large").css("background","url('" + $(".zoom-area .slider.slider-for .slick-current .product__media img").attr("src") + "') no-repeat");
    $(".zoom-area media-gallery .slider.slider-for").mousemove(function(e){
        if(!sub_width && !sub_height)
        {
            var image_object = new Image();
            image_object.src = $(".zoom-area .slider.slider-for .slick-current .product__media img").attr("src");
            sub_width = image_object.width;
            sub_height = image_object.height;
        }
        else
        {
            var magnify_position = $(this).offset();

            var mx = e.pageX - magnify_position.left;
            var my = e.pageY - magnify_position.top;
            
            if(mx < $(this).width() && my < $(this).height() && mx > 0 && my > 0)
            {
                $(".large").fadeIn(100);
            }
            else
            {
                $(".large").fadeOut(100);
            }
            if($(".large").is(":visible"))
            {
                var rx = Math.round(mx/$(".zoom-area .slider.slider-for .slick-current .product__media img").width()*sub_width - $(".large").width()/2)*-1;
                var ry = Math.round(my/$(".zoom-area .slider.slider-for .slick-current .product__media img").height()*sub_height - $(".large").height()/2)*-1;

                var bgp = rx + "px " + ry + "px";
                
                var px = mx - $(".large").width()/2;
                var py = my - $(".large").height()/2;

                $(".large").css({left: px, top: py, backgroundPosition: bgp});
            }
        }
    });
  });
  $(".header__icon--cart").click(function(){
    $(".announcement-bar-section").addClass("hide-bar-j");
  });
  $("cart-drawer").click(function(){
    $(".announcement-bar-section").removeClass("hide-bar-j");
  });
  $(".gifts-top .left-wrap .left-inner .primary-btn").click(function() {
    $('html, body').animate({
        scrollTop: $("#gift-contact-j").offset().top
    }, 500);
  });
});
// var eventHandler = function(name) {
//   return function() {
//     var event = new Event('input', {
//         bubbles: true,
//         cancelable: true,
//     });
      
//     document.querySelector('#SortBy').dispatchEvent(event);
//   };
// };

// $('.facet-filters__sort').selectize({
//   onChange        : eventHandler('onChange')
// });
